import { CSSProperties } from "react";
import { DataScienceJobApi } from "../../api/DataScienceJobApi";

export const TASK_LOGS_MODAL_WIDTH = 800;

export const taskLogsModalStyle = { top: 48 };

export const taskLogsModalBodyStyle = { padding: "12px 16px" };

export const taskLogsScrollContainerStyle: CSSProperties = {
  maxHeight: "50vh",
  overflowY: "auto",
  backgroundColor: "#f8f9fa",
  color: "#495057",
  fontFamily: "Consolas, 'Courier New', monospace",
  fontSize: "13px",
  lineHeight: "1.4",
  padding: "12px",
  borderRadius: "4px",
  border: "1px solid #dee2e6",
};

function parseFilename(contentDisposition?: string): string | undefined {
  if (!contentDisposition) return undefined;
  const match = contentDisposition.match(/filename="?([^";]+)"?/i);
  return match?.[1];
}

export async function downloadTaskLogsFromServer(taskId: string): Promise<void> {
  const response = await DataScienceJobApi.downloadTaskLogs(taskId);
  const filename =
    parseFilename(response.headers["content-disposition"]) ||
    `logs-${taskId}.txt`;

  const url = URL.createObjectURL(
    new Blob([response.data], { type: "text/plain;charset=utf-8" })
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
